import React, { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function adminHeaders() {
  const token = localStorage.getItem("cw_admin_token") || "";
  return { headers: { "x-admin-token": token } };
}

export default function ContactInbox() {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [unread, setUnread] = useState(0);
  const [busy, setBusy] = useState(false);

  const load = async () => {
    setBusy(true);
    try {
      const r = await axios.get(`${API}/admin/contact-messages`, adminHeaders());
      setItems(r.data.items || []);
      setTotal(r.data.total || 0);
      setUnread(r.data.unread || 0);
    } finally { setBusy(false); }
  };

  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    await axios.post(`${API}/admin/contact-messages/status`, { id, status }, adminHeaders());
    load();
  };

  return (
    <div data-testid="admin-contact-inbox">
      <div className="cw-eyebrow">Contact</div>
      <h1 className="cw-display-l" style={{ marginTop: 8 }}>Inbound messages.</h1>
      <p className="cw-body" style={{ marginTop: 8, color: "rgba(22,30,27,0.72)" }}>
        Messages sent through the marketing contact form. {total} total, {unread} unread.
      </p>

      <div className="cw-card" style={{ marginTop: 24, padding: 0 }}>
        <table className="cw-table">
          <thead>
            <tr>
              <th style={{ width: 140 }}>Received</th>
              <th style={{ width: 180 }}>Name</th>
              <th style={{ width: 220 }}>Email</th>
              <th style={{ width: 180 }}>Organisation</th>
              <th>Message</th>
              <th style={{ width: 120 }}>Status</th>
            </tr>
          </thead>
          <tbody>
            {items.map((m) => (
              <tr key={m.id} data-testid={`contact-row-${m.id}`}>
                <td className="cw-tabular" style={{ fontSize: 12.5 }}>
                  {(m.created_at || "").slice(0, 19).replace("T", " ")}
                </td>
                <td>{m.name}</td>
                <td className="cw-tabular" style={{ fontSize: 12.5 }}>{m.work_email}</td>
                <td>{m.organisation}</td>
                <td style={{ maxWidth: 420, whiteSpace: "pre-wrap" }}>{m.message}</td>
                <td>
                  <button
                    className={`pill ${m.status === "NEW" ? "pill-marigold" : "pill-seafoam"}`}
                    style={{ cursor: "pointer", border: 0 }}
                    onClick={() => setStatus(m.id, m.status === "NEW" ? "READ" : "NEW")}
                    data-testid={`contact-toggle-${m.id}`}
                  >
                    {m.status}
                  </button>
                </td>
              </tr>
            ))}
            {!items.length && !busy && (
              <tr><td colSpan={6} style={{ padding: 40, textAlign: "center", color: "rgba(22,30,27,0.55)" }}>No messages yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
